import React from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { rotateMap } from './type';
const IconChevronSmall = (props) => {
    const defaultSize = 14;
    const { size, color, bgColor, sx, className, direction = 'right', ...restProps } = props;
    return (React.createElement(Box, { component: "span", className: clsx('ui-internal-icon', className), display: "inline-flex", sx: {
            color,
            fontSize: size ?? defaultSize,
            background: bgColor,
            ...rotateMap[direction],
            ...sx,
        }, "aria-hidden": true, ...restProps },
        React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6.1675 4.12408C5.93782 4.36294 5.94527 4.74277 6.18414 4.97244L9.33434 7.93994L6.18414 10.9074C5.94527 11.1371 5.93783 11.5169 6.1675 11.7558C6.39718 11.9947 6.777 12.0021 7.01587 11.7724L10.6159 8.37244C10.7335 8.25932 10.8 8.10315 10.8 7.93994C10.8 7.77673 10.7335 7.62056 10.6159 7.50744L7.01587 4.10744C6.777 3.87777 6.39718 3.88521 6.1675 4.12408Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }))));
};
export default IconChevronSmall;
